import { AmpPersonalisation } from "types/amplience";

// Parse the Unica Segment for the User. The format of this string is: "[SEGMENT1|SEGMENT2]"
const parseUnicaSegments = (unicaSegment: string): string[] =>
  unicaSegment.length > 0 ? unicaSegment.slice(1, unicaSegment.length - 1).split("|") : [];

const userMeetsPersonalizationCriteria = (
  user: User | undefined,
  { customerTypeCriteria, customerUnicaSegmentCriteria }: AmpPersonalisation,
): boolean => {
  if (!user) return false;

  const { cva, unicaSegment } = user;
  const parsedUnicaSegments = parseUnicaSegments(unicaSegment);

  // Customer Type is a match if no customer type has been specified OR at least one value
  // in the array matches.
  const customerTypeMatch =
    !customerTypeCriteria ||
    customerTypeCriteria.length === 0 ||
    customerTypeCriteria.some(
      (type) =>
        (type === "Unknown" && cva === "0") || (type === "Credit" && cva === "1") || (type === "Cash" && cva === "2"),
    );

  // Customer Unica Segment is a match if no customer segment has been specified OR at least one value
  // in the array matches.
  const customerUnicaSegmentMatch =
    !customerUnicaSegmentCriteria ||
    customerUnicaSegmentCriteria.length === 0 ||
    customerUnicaSegmentCriteria.some((segment) => parsedUnicaSegments.includes(segment));

  return customerTypeMatch && customerUnicaSegmentMatch;
};

export default userMeetsPersonalizationCriteria;
